<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName"
      ><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="dbgl">
        <span slot="label"
          ><i class="iconfont iconcheck"></i><i class="border"></i> 达标管理
        </span>
        <!-- <normalNav :parent="self">
            <button class="GreenSmBtn download" @click="editDialogVisible=true">添加测评项</button>
          </normalNav> -->
        <div class="w_normalNav" :parent="self">
          <!-- <button class="BlueSmBtn" @click="subSeefrom">搜索</button> -->
          <!-- <button class="OrangeSmBtn" @click="reset">重置</button> -->
          <button class="GreenSmBtn" @click="addTempLate">
            添加测评项
          </button>
        </div>
        <div class="w_content j-sb">
          <table v-for="(item, index) in dataList" :key="index" class="card">
            <tr class="flex j-sb" style="border-bottom: 1px solid #3d4963;padding-bottom: 10px;">
              <td>
                <span style="font-size: 16px;font-weight:bold">{{
                  item.typeStr
                }}</span>
                <span> >  &nbsp;{{ item.levelStr }}</span>
              </td>
              <td class="flex btnList">
                <div>
                  <button class="GreenSmBtn" @click="zpClick(index)">
                    自评
                  </button>
                </div>
                <div>
                  <button class="OrangeSmBtn" @click="editClick(item)">
                    编辑
                  </button>
                </div>
                <div>
                  <button class="RedSmBtn" @click="del(item)">
                    删除
                  </button>
                </div>
              </td>
            </tr>
            <tr class="flex">
              <td>{{ item.judgeStandard }}</td>
            </tr>
            <tr class="flex">
              <td style="width: 10%;">情况说明</td>
              <td style="width: 90%;">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="item.selfDescription"
                  :disabled="disabled"
                >
                </el-input>
              </td>
            </tr>
            <tr class="flex" style="border-top: 1px solid #3d4963;padding-top: 10px;">
              <td style="width: 20%;"><span style="margin-right: 10px;">分值 </span>{{ item.totalScore }}</td>
              <td style="width: 20%;"><span style="margin-right: 10px;">自评得分</span>{{ item.selfJudgeScore }}</td>
              <td style="width: 56%;" class="flex"><span style="margin-right: 10px;">附件</span> 
                <div >
                  <span class="flex" v-for="(i,index) in item.fileAddressList" :key="index">
                    <a :src="i" :href="i.fileUrl" target="_blank" style="color: #cacaca;">{{ i.fileName }}</a>
                    &nbsp;&nbsp;
                    <!-- <span @click="downloadImage(i.fileUrl,i.fileName)"
                    class="download" style="color: #fff;">下载</span> -->
                    <a :download="i.fileName" :href="i.fileUrl" target="_blank"
                    class="download" style="color: #cacaca;">下载</a>
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <el-dialog
          class="editDialog"
          title="添加测评项"
          :visible.sync="editDialogVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="form1"
              :model="form1"
              :rules="rule"
              label-position="right"
            >
              <el-form-item label="测评项类别" prop="typeId">
                <el-select
                  v-model="form1.typeId"
                  placeholder="请选择测评项类别"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="(item, index) in standardEvaluationTypeArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="评定标准" prop="judgeStandard">
                <el-input
                  v-model="form1.judgeStandard"
                  placeholder="请输入评定标准"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="评定标准项序号" prop="sort">
                <el-input
                  v-model="form1.sort"
                  placeholder="请输入评定标准项序号"
                ></el-input>
              </el-form-item>
              <el-form-item label="分值" prop="totalScore">
                <el-input
                  v-model="form1.totalScore"
                  placeholder="请输入分值"
                  step="0.1"
                ></el-input>
              </el-form-item>
              <el-form-item label="检查方法" prop="checkStandard">
                <el-input
                  v-model="form1.checkStandard"
                  placeholder="请输入检查方法"
                  type="textarea"
                ></el-input>
              </el-form-item>

              <el-form-item label="重要等级" prop="level">
                <el-select v-model="form1.level" placeholder="请输入重要等级">
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="(item, index) in standardEvaluationLevelArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </section>

          <div slot="footer" class="dialog-footer">
            <el-button class="confirmButton" type="primary" @click="sumbit"
              >提交</el-button
            >
            <el-button
              class="cancelButton"
              type="primary"
              @click="editDialogVisible = false"
              >取消</el-button
            >
          </div>
        </el-dialog>

        <el-dialog
          class="editDialog"
          title="自评"
          :visible.sync="detailsVisible"
          :close-on-click-modal="false"
        >
          <section class="list">
            <el-form
              ref="zpForm"
              :model="other"
              :rules="rule"
              label-position="right"
            >
            <el-form-item label="测评项类别">
                <el-select
                  v-model="other.typeId"
                  placeholder="请选择测评项类别"
                  :disabled="true"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="(item, index) in standardEvaluationTypeArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="评定标准">
                <el-input
                  v-model="other.judgeStandard"
                  placeholder="请输入评定标准"
                  type="textarea"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="评定标准项序号">
                <el-input
                  v-model="other.sort"
                  placeholder="请输入评定标准项序号"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="分值">
                <el-input
                  v-model="other.totalScore"
                  placeholder="请输入分值"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="检查方法">
                <el-input
                  v-model="other.checkStandard"
                  placeholder="请输入检查方法"
                  type="textarea"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="重要等级">
                <el-select v-model="other.level" placeholder="请输入重要等级" :disabled="true">
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="(item, index) in standardEvaluationLevelArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="自评分值" prop="selfJudgeScore">
                <el-input
                  v-model="other.selfJudgeScore"
                  placeholder="请输入自评分值"
                ></el-input>
              </el-form-item>
              <el-form-item label="情况说明" prop="selfDescription">
                <el-input
                  v-model="other.selfDescription"
                  placeholder="请输入情况说明"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="附件">
                <div class="flex f-dc">
                  <div v-for="(i,index) in other.fileAddressList" :key="index" >
                    <a :src="i" :href="i.fileUrl" target="_blank" style="color: #cacaca;">{{ i.fileName }}</a>
                    <span @click="delPic(index)" style="cursor: pointer;">删除</span>
                  </div>
                </div>
                <el-upload-secondary
                  class="YnormalCard"
                  v-model="other.assetPic"
                  :limit="5"
                  accepts="xls,xlsx,pdf,png,jpg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload-secondary>
                <div
                  class="el-form-item__error"
                  v-show="!other.assetPic || other.assetPic.length == 0"
                  slot="error"
                >
                  请上传附件
                </div>
              </el-form-item>
            </el-form>
          </section>
          <div slot="footer" class="dialog-footer">
            <el-button
              class="confirmButton"
              type="primary"
              @click="ziping"
              >提交</el-button
            >
            <el-button
              class="cancelButton"
              type="primary"
              @click="detailsVisible = false"
              >返回</el-button
            >
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { obj2urlsp, descriptor } from "utils";
export default {
  data() {
    return {
      tabName: 'dbgl',
      editLoading: true,
      editDialogVisible: false,
      detailsVisible: false,
      detailsList: [],
      form1: {

      },
      zpForm:{},
      other:{},
      assetPic: [],
      disabled: true,
      dataList: [],
      standardEvaluationTypeArr: [],
      standardEvaluationLevelArr: [],
      isEdit:false
    };
  },
  watch: {
    editDialogVisible(n) {
      this.$nextTick(() => {
        if (!n) {
          this.form1={}
          this.$refs["form1"].resetFields();
        }
      });
      // this.$ref["form1"].resetFields();
      // this.form1={}
    },
    detailsVisible(n) {
      this.$nextTick(() => {
        if (!n) {
          this.zpForm={}
          this.$refs["zpForm"].resetFields();
        }
      });
      // this.$ref["zpForm"].resetFields();
      // this.xgPicList = [];
      this.zpForm.assetPic=[];
    }
  },
  computed: {
    self() {
      return this;
    },
    rule() {
      let that = this;
      return {
        typeId: [
          {
            required: true,
            message: "请输入测评项类别",
            trigger: "blur",
          },
        ],
        judgeStandard: [
          {
            required: true,
            message: "请输入情况说明",
            trigger: "blur",
          },
        ],
        sort: descriptor(new Map([
          [true, "请输入评定标准序号"],
          [() => /^[1-9]\d*$/.test(that.form1.sort), '请输入正整数']
        ]), "blur"),
        totalScore:descriptor(new Map([
          [true, "请输入分值"],
          [() => /^([0-9]\d{0,1}|99.9)(\.\d{1})?$/.test(that.form1.totalScore), '请输入小于100并且不能大于一位小数']
        ]), "blur"),
        checkStandard: [
          {
            required: true,
            message: "请输入检查方法",
            trigger: "blur",
          },
        ],
        level: [
          {
            required: true,
            message: "请输入重要等级",
            trigger: "blur",
          },
        ],
        selfJudgeScore:descriptor(new Map([
          [true, "请输入自评分值"],
          [() => /^([0-9]\d{0,1}|99.9)(\.\d{1})?$/.test(that.other.selfJudgeScore), '请输入小于100并且不能大于一位小数']
        ]), "blur"),
        selfDescription: [
          {
            required: true,
            message: "请输入情况说明",
            trigger: "blur",
          },
        ]
      };
    }
  },
  methods: {
    del(item){
      this.$confirm("确定删除测评项?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning",
      }).then(() => {
        this.$axiosget(`extra/standardEvaluation/removeTemplateByKey/${item.evaluationId}`).then((res) => {
          this.getData();
          this.$message.success("删除成功");
        });
      });
    },
    zpClick(index){
      this.detailsVisible = true
      // this.$refs["zpForm"].resetFields();
      this.zpForm=this.dataList[index]
      this.other={...this.zpForm}
      // console.log(this.zpForm);
      // this.assetPic=this.dataList[index].fileAddressList
    },
    addTempLate(){
      this.editDialogVisible = true
      this.isEdit=false
      // this.$refs["form1"].resetFields();
    },
    sumbit() {
      this.$refs["form1"].validate(valid => {
        if (valid) {
          let arr = [];
          let object = { ...this.form1 };
          if(!this.isEdit){
              this.$axiospost("extra/standardEvaluation/addTemplate", object).then(
                res => {
                  if (res.data.status === "10000" || res.data.status === 10000) {
                    this.$message.success("提交成功！");
                  }
                  this.editLoading = false;
                  this.editDialogVisible = false;
                  // this.$refs["table_xjrwgl"].getData();
                  this.getData()
                }
              );
          }else{
            this.$refs["form1"].validate(valid => {
              if (valid) {
                let arr = [];
                let object = { ...this.form1 };
                this.$axiospost("extra/standardEvaluation/updateTemplate", object).then(
                  res => {
                    if (res.data.status === "10000" || res.data.status === 10000) {
                      this.$message.success("编辑成功！");
                    }
                    this.editLoading = false;
                    this.editDialogVisible = false;
                    // this.$refs["table_xjrwgl"].getData();
                    this.getData()
                  }
                );
              }
            });
          }
        }
      });
    },
    ziping() {
      this.$refs["zpForm"].validate(valid => {
        if (valid) {
          let arr = [];
          let object = { ...this.other,};
          if (this.other.assetPic) {
            // this.form1.assetPic.forEach((i)=>arr.push( i.response.data[0] ))
            this.other.assetPic.forEach(i =>
              arr.push({fileUrl:
                i.response.data[0].startsWith("http")
                  ? i.response.data[0]
                  : process.env.fileUrl + "/" + i.response.data[0],
                fileName:i.name}
              )
            );
          }
          this.$axiospost("extra/standardEvaluation/fillData", 
          {evaluationId:object.evaluationId,selfJudgeScore:object.selfJudgeScore,selfDescription:object.selfDescription,fileList: arr.concat(object.fileAddressList||[])}).then(
            res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success(res.data.data);
              }
              this.editLoading = false;
              this.detailsVisible = false;
              // this.$refs["table_xjrwgl"].getData();
              this.getData()
            }
          );
        }
      });
    },
    editClick(item){
      this.editDialogVisible = true
      this.isEdit=true
      this.form1={...item}
    },
    delPic(index){
      this.zpForm.fileAddressList.splice(index,1)
    },
    downloadImage(src, imgName) {
      let image = new Image();
 
      image.src = src;
  
      image.setAttribute("crossOrigin", "anonymous");
  
      image.onload = function() {
      
          let c = document.createElement("canvas");
  
          c.width = image.width;
  
          c.height = image.height;
  
          c.getContext("2d").drawImage(image, 0, 0, image.width, image.height);
      
          let a = document.createElement("a"); 
  
          a.download = imgName;
  
          a.href = c.toDataURL("image/png");
          a.target = "_blank";
  
          a.click();
      
      }
    },
    getData() {
      this.$axiosget("extra/standardEvaluation/getList").then(res => {
        this.dataList = res.data.data;
      });
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    nextCompany: () => import("public/nextCompany")
  },
  mounted() {
    this.getData()
    this.$axiosget("operation/dictionaryType/queryByKey", {
      params: {
        key: "standardEvaluationType"
      }
    }).then(res => {
      if (res.data.status === "10000") {
        this.standardEvaluationTypeArr = res.data.data
          ? res.data.data.list
          : [];
      }
    });
    this.$axiosget("operation/dictionaryType/queryByKey", {
      params: {
        key: "standardEvaluationLevel"
      }
    }).then(res => {
      if (res.data.status === "10000") {
        this.standardEvaluationLevelArr = res.data.data
          ? res.data.data.list
          : [];
      }
    });
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #cacaca;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom: 1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
/deep/ .editDialog .el-form-item__label {
  text-align: right !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
  font-size: 10px;
}
.el-form-item__content {
  img {
    max-width: 400px;
    max-height: 400px;
  }
}
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.w_content {
  color: #cacaca;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .btnList {
    > div {
      margin: 0 0 0 20px;
    }
  }
  .card {
    border-radius: 6px;
    border: 1px solid #3d4963;
    width: calc(50% - 20px);
    height: 330px;
    margin: 10px 10px;
    overflow-y: scroll;
    /deep/ .el-textarea.is-disabled .el-textarea__inner{
      background: transparent;
    }
    > tr {
      width: 100%;
      margin-top: 24px;
      padding: 0 18px;
      height: 15%;
      td {
        width: auto;
      }
    }
  }
  table {
    border-spacing: 10px;
  }
}
.flex {
  display: flex;
}
.a-c {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-se {
  justify-content: space-evenly;
}
.f-dc {
  flex-direction: column;
}
.download{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/standardEvaluation/standardManagement/index.vue